import styles from "../../styles/expenses.create.statement.modal.module.css";
import React from "react";
import {AmountInput} from "./AmountInput";
import {RemoveButton} from "./RemoveButton";

const VAT_RATE = 0.13;


//компонент таблицы сотрудников

export const StaffTable = ({selectedStaff, staffAmounts, handleAmountChange, handleRemoveStaff, totals}) => {
    const calculateVAT = (amount) => Math.round(amount * VAT_RATE * 100) / 100;

    if (selectedStaff.length === 0) return null;

    return (
        <div className={styles.staffTableContainer}>
            <div className={styles.tableHeader}>
                <div>Сотрудник</div>
                <div>Наличные (€)</div>
                <div>Безнал без НДС (€)</div>
                <div>Безнал с НДС (€)</div>
                <div></div>
            </div>

            {selectedStaff.map(staff => {
                const amounts = staffAmounts[staff.id] || {cash: 0, nonCashWithoutVAT: 0, nonCashWithVAT: 0};
                const vatAmount = calculateVAT(amounts.nonCashWithoutVAT);

                return (
                    <div key={staff.id} className={styles.staffRow}>
                        <div className={styles.staffInfo}>
                            <div>
                                <div className={styles.staffName}>{staff.fullName}</div>
                                <div className={styles.staffId}>ID: {staff.id}</div>
                            </div>
                        </div>

                        <AmountInput
                            value={amounts.cash}
                            onChange={(value) => handleAmountChange(staff.id, 'cash', value)}
                        />

                        <div>
                            <AmountInput
                                value={amounts.nonCashWithoutVAT}
                                onChange={(value) => handleAmountChange(staff.id, 'nonCashWithoutVAT', value)}
                            />
                        </div>

                        <div>
                            <AmountInput
                                value={amounts.nonCashWithVAT}
                                onChange={(value) => handleAmountChange(staff.id, 'nonCashWithVAT', value)}
                            />
                        </div>

                        <div className={styles.buttonRight}>
                            <RemoveButton onClick={() => handleRemoveStaff(staff.id)}/>
                        </div>
                    </div>
                );
            })}

            {/* Итоговая строка */}
            <div className={styles.totalsRow}>
                <div>ИТОГО:</div>
                <div>{totals.totalCash.toFixed(2)} €</div>
                <div>{totals.totalNonCashWithoutVAT.toFixed(2)} €</div>
                <div>{totals.totalNonCashWithVAT.toFixed(2)} €</div>
                <div></div>
            </div>
        </div>
    );
};